<div class="w-full grid grid-cols-1">
    <app-wip-datatable 
    [wipType]="wipType" 
    [searchForm]="searchForm"
    [dt]="dt" 
    [downloadPath]="downloadPath" 
    [sortInfo]="sortInfo"
    [columnSort]="columnSort"
    (setPage)="setPage($event)" 
    (resetPage)="reset()"
    (addRecord)="formDialog()"
    ></app-wip-datatable>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-other-activity-grid  z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="flex justify-center items-center border py-8">
                No
            </div>

            <div [mat-sort-header]="'activityName'" class="flex justify-center border py-4">
                Name
            </div>

            <div [mat-sort-header]="'activityCompletion'" class="flex justify-center border py-8">
                Completion (%)
            </div>

            <div class="flex justify-center items-center border py-8">
                Action
            </div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-other-activity-grid grid items-center border-b" [ngClass]="{'bg-primary-100': i % 2 }">
                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Name -->
                    <div class="flex truncate justify-center">
                        {{ row.activityName || '-'  }}
                    </div>

                    <!-- Completion -->
                    <div class="flex truncate justify-center">
                        {{ row.activityCompletion || '-'  }}
                    </div>

                    <!-- action -->
                    <div class="flex justify-center">
                        <button class="btn btn-remove-bg px-2" (click)="formDialog(row)">
                            <mat-icon class="text-primary" [svgIcon]="'heroicons_solid:pencil-square'" matTooltip="Edit"></mat-icon>
                        </button>

                        <button class="btn btn-remove-bg px-2" (click)="deleteRecord(row)">
                            <mat-icon class="text-error" [svgIcon]="'heroicons_outline:trash'" matTooltip="Delete"></mat-icon>
                        </button>
                    </div>

                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>
</div>
